// cspell:disable
export const AdUrls = Object.freeze({
  ADD_VARIETY_ZONE: 'addvariety',
  ADX: 'adx',
  AMPERSAND: '&',
  BACKSTAGE_ZONE: 'backstage',
  C: 'c',
  COMMA: ',',
  CREATESTATION_ZONE: 'createstation',
  D_IMP: 'd_imp',
  DC_REF: 'dc_ref',
  DEFAULT: 'default',
  DEFAULT_DFP_NETWORK_CODE: '4204',
  DFP_SERVER: 'pubads.g.doubleclick.net/gampad/',
  EMPTY_STRING: '',
  ENCODED_COMMA: '%2C',
  EQUALS: '=',
  HTTP: 'http://',
  HTTPS: 'https://',
  IP: 'ip',
  IU: 'iu',
  MDID: 'mdid',
  ORD: 'ord',
  PAND: 'pand',
  PERIOD: '.',
  PIPE: '|',
  PPID: 'ppid',
  PROD: 'prod',
  RADIO_ZONE: 'radio',
  REF: 'ref',
  SEMI_COLON: ';',
  SHARE_ZONE: 'share',
  SLASH: '/',
  SS_REQ: 'ss_req',
  STATION: 'station',
  SZ: 'sz',
  T: 't',
  THEMEDSTATION_ZONE: 'themedstation',
  TILE: 'tile',
  TRIAL_ZONE: 'trial',
} as const);

export const DisplayAdActions = Object.freeze({
  CHECK_AND_CLEAR_COMPANION_FLAG: 'CHECK_AND_CLEAR_COMPANION_FLAG',
  CLEAR_CAN_SHOW_ADS_ON_PAGE: 'CLEAR_CAN_SHOW_ADS_ON_PAGE',
  CLEAR_COMPANION_FLAG: 'CLEAR_COMPANION_FLAG',
  CLEAR_DISPLAY_AD_INTERACTION: 'CLEAR_DISPLAY_AD_INTERACTION',
  DISPLAY_AD_FRAME_LOADED: 'DISPLAY_AD_FRAME_LOADED',
  INCREMENT_DISPLAY_AD_INDEX: 'INCREMENT_DISPLAY_AD_INDEX',
  REMOVE_AUDIO_AD_COMPANION_APS: 'REMOVE_AUDIO_AD_COMPANION_APS',
  REMOVE_DISPLAY_ADS: 'REMOVE_DISPLAY_AD',
  REMOVE_INACTIVE_DISPLAY_AD: 'REMOVE_INACTIVE_DISPLAY_AD',
  RENDER_AUDIO_AD_COMPANION_APS: 'RENDER_AUDIO_AD_COMPANION_APS',
  SET_AD_SKIN_URL: 'SET_AD_SKIN_URL',
  SET_AD_SUBZONE: 'SET_AD_SUBZONE',
  SET_AD_URL_TARGETING_ATTRIBUTES: 'SET_AD_URL_TARGETING_ATTRIBUTES',
  SET_CAN_SHOW_ADS_ON_PAGE: 'SET_CAN_SHOW_ADS_ON_PAGE',
  SET_COMPANION_FLAG: 'SET_COMPANION_FLAG',
  SET_DISPLAY_AD_INTERACTION: 'SET_DISPLAY_AD_INTERACTION',
  SET_DISPLAY_AD_TIMESTAMP: 'SET_DISPLAY_AD_TIMESTAMP',
  SET_DISPLAY_AD_TYPE: 'SET_DISPLAY_AD_TYPE',
  SET_DISPLAY_AD_URL: 'SET_DISPLAY_AD_URL',
  TOGGLE_ACTIVE_DISPLAY_AD: 'TOGGLE_ACTIVE_DISPLAY_AD',
} as const);

export const DisplayAdKeys = Object.freeze({
  AD_SKIN_ONE_KEY: 'AD_SKIN_ONE_KEY',
  AD_SKIN_TWO_KEY: 'AD_SKIN_TWO_KEY',
  AD_SUBZONE_KEY: 'AD_SUBZONE_KEY',
  AD_URL: 'AD_URL',
  ADS_DISPLAY_AD_DATA: 'ADS_DISPLAY_AD_DATA',
  COMPANION_AD_ACTIVE_KEY: 'COMPANION_AD_ACTIVE_KEY',
  CORRELATION_ID: 'CORRELATION_ID',
  DISPLAY_AD_ALLOWED_ON_PAGE_KEY: 'DISPLAY_AD_ALLOWED_ON_PAGE_KEY',
  DISPLAY_AD_INDEX: 'DISPLAY_AD_INDEX',
  DISPLAY_AD_INTERACTION: 'DISPLAY_AD_INTERACTION',
  DISPLAY_AD_INTERACTION_KEY: 'DISPLAY_AD_INTERACTION_KEY',
  DISPLAY_AD_ONE_TYPE_KEY: 'DISPLAY_AD_ONE_TYPE_KEY',
  DISPLAY_AD_ONE_URL_KEY: 'DISPLAY_AD_ONE_URL_KEY',
  DISPLAY_AD_TIMESTAMP_KEY: 'DISPLAY_AD_TIMESTAMP_KEY',
  DISPLAY_AD_TWO_TYPE_KEY: 'DISPLAY_AD_TWO_TYPE_KEY',
  DISPLAY_AD_TWO_URL_KEY: 'DISPLAY_AD_TWO_URL_KEY',
  IS_DISPLAY_AD_ONE_ACTIVE_KEY: 'IS_DISPLAY_AD_ONE_ACTIVE_KEY',
  NEXT_DISPLAY_AD_TIMESTAMP_KEY: 'NEXT_DISPLAY_AD_TIMESTAMP_KEY',
} as const);

export const DisplayAdConstants = Object.freeze({
  AD_CONTAINER_ONE: 'DisplayAdController__adContainerOne',
  AD_CONTAINER_TWO: 'DisplayAdController__adContainerTwo',
  AD_SUBZONE_BACKSTAGE: 'AD_SUBZONE_BACKSTAGE',
  AD_SUBZONE_NOW_PLAYING: 'AD_SUBZONE_NOW_PLAYING',
  AD_UNIT: '/4204/pand.default/prod.radio',
  ALLOWED_SLOT_SIZES: '2000x2,300x250,300x600', // supported display ad sizes
  ASYNC_GPT_AD: 'ASYNC_GPT_AD',
  DISPLAY_AD_FADE_SPEED: 500, // milliseconds
  DISPLAY_AD_STARTING_INDEX: 1,
  DOUBLE_WIDE: 'double_wide',
  MASTHEAD: 'masthead',
  MEDIUM_RECTANGLE: 'medium_rectangle',
  SECONDS_SINCE_DISPLAY_AD_SENTINEL: -1,
  TIME_BETWEEN_DISPLAY_ADS: 4000,
  UNDEFINED_AD_ASSET: '',
} as const);

export const IasScriptEndpoints = Object.freeze({
  IAS_GPT_URL: 'https://www.googletagservices.com/tag/js/gpt.js',
  IAS_PET_URL: 'https://cdn.adsafeprotected.com/iasPET.1.js',
} as const);
